import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.mail.index'),
        name: 'mail.index',
        component: () =>
            import(/* webpackChunkName: "mails" */ '@/views/mails/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.mail.breadcrumb.index'),
                    to: { name: 'mail.index' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('routes.mail.edit') + '/:id',
        name: 'mail.edit',
        component: () =>
            import(/* webpackChunkName: "mails" */ '@/views/mails/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.mail.breadcrumb.index'),
                    to: { name: 'mail.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.mail.breadcrumb.edit'),
                    to: { name: 'mail.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
